import { render, staticRenderFns } from "./CreateCategory.vue?vue&type=template&id=338c19e6&"
import script from "./CreateCategory.vue?vue&type=script&lang=ts&"
export * from "./CreateCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports